import { IconButton } from '@rmwc/icon-button'
import '@rmwc/icon-button/styles'

export default IconButton
